import config from '../../config/config';
import getFirstSubdomain from '../../shared-functions/DomiansplitFunction';

import getRequest from './base/get';
import postRequest from './base/post';
import BrandingService from './branding';

interface QueryParameters {
  [key: string]: any;
}

export default {
  /**
   * Fetch a device
   * @param deviceSN
   */
  // sendCardDetails: (data: any) => {
  //   return postRequest(
  //     `${process.env.REACT_APP_TRANSACTION_API_URL}api/guest/v1/stripe-payment/create-stripe-customer`,
  //     data,
  //   );
  // },
  /**
   * Fetch a device
   * @param deviceSN
   */
  fetchOneDevicePoints: (deviceSN: string | number) => {
    return getRequest(`${config.commonApiUrl}api/guest/v1/charging-point/${deviceSN}`);
  },
  /**
   * Generate Temp Token to start charging
   */
  generateTempToken: () => {
    return getRequest(`${config.ocppApiUrl}api/ocpp16/v1/guest/generate-guest-token`);
  },
  /**
   * Start charging
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  startCharging: (data: any): Promise<any> => {
    return postRequest(`${config.ocppApiUrl}api/ocpp16/v1/guest/remote-start-transaction`, data);
  },
  /**
   * Stop charging
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  stopCharging: (data: any): Promise<any> => {
    return postRequest(`${config.ocppApiUrl}api/ocpp16/v2/guest/remote-stop-transaction`, data);
  },
  /**
   * Stop charging
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  getTransaction: (data: any): Promise<any> => {
    return postRequest(`${config.ocppApiUrl}api/ocpp16/v1/guest/latest-transaction`, data);
  },
  /**
   * Function to refresh charging session
   * @param data
   * @returns
   */
  refreshSession: (data: any): Promise<any> => {
    return getRequest(`${config.reportApiUrl}api/guest/v1/charging-transaction`, data);
  },
  /**
   * Return Api call
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  getReturnApiCall: (query: string): Promise<any> => {
    const domain = getFirstSubdomain();
    const brandData = BrandingService.getCachedBranding();
    return getRequest(
      `${domain && brandData?.transactionApiUrl ? brandData?.transactionApiUrl : process.env.REACT_APP_TRANSACTION_API_URL}api/end-consumer/v1/hyperpay-payment/registration-status/${query}`,
      {},
    );
  },
  /**
   * Return Api call
   * @param data
   * @param onUploadProgress Optional callback for tracking upload progress
   */
  fetchIdleFee: (query: QueryParameters): Promise<any> => {
    const parameters = { ...query };
    return getRequest(`${config.commonApiUrl}api/guest/v1/penalty-management`, { ...parameters });
  },
  /**
   * Fetch active session
   */
  fetchActiveSession: (userCustomId: string, query: QueryParameters = {}): Promise<any> => {
    const parameters = { ...query };
    return getRequest(
      `${config.reportApiUrl}api/guest/v1/end-consumer/get-active-session/${userCustomId}`,
      {
        ...parameters,
      },
    );
  },
};
